import type { SetStateAction } from 'react'
import { ConversationTrigger } from '../types/AIResponseTypes'
import type { GenerateAIResponseProps } from '../types/ChatMessagesContextTypes'
import { type ChatbotMessage, MessageRole } from '../types/messageTypes'

export const regenerateFA = ({
	setChatHistoryMessages,
	generateAIResponse,
}: {
	setChatHistoryMessages: (value: SetStateAction<ChatbotMessage[]>) => void
	generateAIResponse: (props: GenerateAIResponseProps) => Promise<void>
}) => {
	setChatHistoryMessages((prevMessages) => {
		const lastHumanMessageIndex = prevMessages.findLastIndex(
			(message) => message.role === MessageRole.Human
		)
		return prevMessages.slice(0, lastHumanMessageIndex + 1)
	})
	generateAIResponse({
		conversationTrigger: ConversationTrigger.RegenerateSearch,
	})
}
